interface FirstVisitSetupCardProps {
  onSetup: () => void;
  onDismiss: () => void;
}

function FirstVisitSetupCard({
  onSetup,
  onDismiss,
}: FirstVisitSetupCardProps): JSX.Element {
  return (
    <div className="border border-dropDownBorder rounded-md p-6 mb-8 bg-white">
      <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-lg bg-lightBlue flex items-center justify-center flex-shrink-0">
            <svg
              className="text-primary"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
            >
              <path
                d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2Zm6-6V11c0-3.07-1.64-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2Z"
                fill="currentColor"
              />
            </svg>
          </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-lg font-bold text-royalBlue">
            Stay informed, on your terms.
          </h3>
          <p className="text-sm text-textSecondaryGray mt-2">
            Choose email, SMS or fax, then set one delivery schedule.
            Your preferences apply across your organizations.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 pt-4 border-t border-dropDownBorder">
            <div>
              <p className="text-xs font-semibold uppercase text-textSecondaryGray tracking-wide">
                Channels
              </p>
              <p className="text-sm text-royalBlue mt-1">Email, SMS or fax</p>
            </div>
            <div className="md:border-l md:border-dropDownBorder md:pl-4">
              <p className="text-xs font-semibold uppercase text-textSecondaryGray tracking-wide">
                Delivery
              </p>
              <p className="text-sm text-royalBlue mt-1">
                Immediately or a scheduled summary
              </p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-4 mt-6">
            <button
              type="button"
              onClick={onSetup}
              className="primaryBtn px-5 py-2 font-semibold"
            >
              Set up preferences →
            </button>
            <button
              type="button"
              onClick={onDismiss}
              className="text-sm text-primary font-semibold"
            >
              Not now
            </button>
          </div>
          <p className="text-xs text-textSecondaryGray mt-4">
            Your existing delivery settings stay in place until you save.
          </p>
        </div>
      </div>
    </div>
  );
}

export default FirstVisitSetupCard;
